import { useEffect, useState } from 'react';
import orgService from '../../../services/orgService';
import { useUser } from '../../authentication';
import licenseService from '../../../services/licenseService';
import { Training } from '../models/training';
import { UserTrainingAccess } from '../models/UserTrainingAccess';
import { isCourse } from '../utils/isCourse';
export const useTrainingAccess = (training?: Training): UserTrainingAccess => {
  const { user } = useUser();
  const orgId = user?.lastSelectedAccount;

  const [hasIndividualGridSubscription, setHasIndividualGridSubscription] = useState(false);
  const [hasGridSubscription, setHasGridSubscription] = useState(false);
  const [hasIndividualLicenseForItem, setHasIndividualLicenseForItem] = useState(false);
  const [canAccess, setCanAccess] = useState(false);
  const [hasPaidForCourse, setHasPaidForCourse] = useState(false);
  const isAdmin = user?.permissions?.includes('Account View') ?? false;
  const hasAssignPermission = user?.permissions?.includes('Assign View') ?? false;
  const isGroupLeader = user?.permissions?.includes('Group Leader') ?? false;
  const canAssign = hasAssignPermission || isGroupLeader || isAdmin;

  useEffect(() => {
    if (training && orgId) {
      orgService.hasIndividualSubscription(orgId).then((hasIndividualGridSubscription: boolean) => {
        setHasIndividualGridSubscription(hasIndividualGridSubscription);
      });

      licenseService.getPairedLicenses(orgId).then((licenses: { isGridSubscription: boolean; expired: boolean }[]) => {
        const userHasGridSubscription =
          licenses.filter(function (license) {
            return license.isGridSubscription && !license.expired;
          }).length > 0;
        setHasGridSubscription(userHasGridSubscription);

        setCanAccess(
          (training.searchAccess === 'Paid' && userHasGridSubscription) || (training.searchAccess === 'Free' && !!orgId)
        );
      });
    }
  }, [orgId, training]);

  useEffect(() => {
    if (training) {
      // TODO: Should we just consider the training accessible if training.hasAccess is true?
      setHasPaidForCourse(!(isCourse(training) && !training?.hasAccess && !training?.isIncludedWithGridSubscription));

      if (training.searchAccess === 'Paid') {
        licenseService.getIndividualLicenses().then((licenses: { expired: boolean; item?: { number: string } }[]) => {
          setHasIndividualLicenseForItem(
            licenses.some(license => license.expired !== true && license.item?.number === training.itemNumber)
          );
        });
      }
    }
  }, [training]);

  return {
    isAdmin,
    hasAssignPermission,
    isGroupLeader,
    canAssign,
    hasIndividualGridSubscription,
    hasGridSubscription,
    hasIndividualLicenseForItem,
    hasPaidForCourse,
    canAccess,
  };
};
